export default __webpack_public_path__ + "static/media/drawn-emission-icon.0fc16b3c.svg";